(() => {
  angular
    .module('complianceFrameworkApp.complianceFramework')
    .controller('EditOrderController', EditOrderController);

  /* ngInject */
  function EditOrderController($state, $stateParams, Flash, sessionService, orderService, formErrorsService, stripePlanService, usStates, fiTypes, paymentTypes) {
    const vm = this;

    angular.extend(vm, formErrorsService);
    angular.extend(vm, stripePlanService);

    vm.activate = activate;
    vm.order = {};
    vm.orderForm = {};
    vm.getOrder = getOrder;
    vm.updateOrder = updateOrder;
    vm.states = usStates;
    vm.fiTypes = fiTypes;
    vm.stripePlans = {};
    vm.getStripePlans = getStripePlans;
    vm.paymentTypes = paymentTypes;

    vm.activate();

    function activate() {
      vm.getOrder();
      vm.getStripePlans();
    }

    function getStripePlans() {
      stripePlanService(sessionService.getAuthToken()).query(response => {vm.stripePlans = response;});
    }

    function getOrder() {
      orderService(sessionService.getAuthToken()).get({id: $stateParams.id}, response => {vm.order = response;});
    }

    function updateOrder(order) {
      vm.clearFormErrors();
      orderService(sessionService.getAuthToken()).update(
        {id: $stateParams.id},
        {order},
        _updateOrderSuccess,
        _updateOrderFailure
      );
    }

    function _updateOrderSuccess(_response) {
      Flash.create('success', 'The order was successfully updated.');
      $state.go('application.compliance_framework.orders');
    }

    function _updateOrderFailure(response) {
      vm.setFormErrors(vm.orderForm, response);
    }

  }
})();
